import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import {
  PrTable,
  PrTableColumn,
} from '@app/components/pr-table/pr-table.component';
import * as _ from 'lodash';
import { takeWhile } from 'rxjs';
import {
  SimulationPack,
  SimulationPackService,
} from '../simulation-pack.service';

@Component({
    selector: 'simulation-pack-table',
    templateUrl: './simulation-pack-table.component.html',
    styleUrls: ['./simulation-pack-table.component.scss'],
    standalone: false
})
export class SimulationPackTableComponent implements OnInit, OnDestroy {
  alive: boolean = true;
  edited = false;
  label: string = 'Modifier';
  @Input() set simulation(simulation) {
    this._simulation = simulation;
    if (
      this.simulationPackService.tableData &&
      this.simulationPackService.tableData.length
    )
      this.initTable();
  }
  get simulation() {
    return this._simulation;
  }
  _simulation?: any;

  @Input() canEdit?: boolean = false;
  @Output() onEdit: EventEmitter<any> = new EventEmitter();

  constructor(protected simulationPackService: SimulationPackService) {
    this.simulationPackService.selectedPackSubject
      .pipe(takeWhile(() => this.alive))
      .subscribe(() => {
        if (
          this.simulationPackService.tableData &&
          this.simulationPackService.tableData.length
        )
          this.initTable();
      });

    this.simulationPackService.tableSubject
      .pipe(takeWhile(() => this.alive))
      .subscribe(() => this.initTable());
  }

  ngOnInit() {
    switch (this.simulation.type) {
      case 'SCPI':
        this.label = 'Modifier les SCPI';
        break;
      case 'ASSURANCE_VIE':
        this.label = 'Modifier les supports';
        break;
      case 'PER':
        this.label = 'Modifier les supports';
        break;
      default:
        this.label = 'Modifier';
        break;
    }
    this.tableData.columns = (this.tableData.columns ?? []).map(item => {
      return {
        ...item,
        shortlabel:
          item.name === 'perfP3Y'
            ? 'Perf. sur 3ans'
            : item.name === 'ponderation'
              ? 'Répartition'
              : item.name === 'volat3Y'
                ? 'Vol. 3ans'
                : item.label,
      };
    });
    this.edited = false;
  }

  tableData = new PrTable([], this.simulationPackService.tableDefinitionColumn);

  initTable(data?: any) {
    const modifiedData = data || this.simulationPackService.tableData;

    this.tableData = new PrTable(
      _.map(modifiedData, d => {
        let obj = {};
        _.forEach(this.simulationPackService.tableDefinitionColumn, col => {
          let value: any = col.options.value;
          if (col.name === 'name' && d.support) {
            const name = d.support.label || '';
            const isinCode = d.support.isinCode || '';
            obj[col.name] = { name: name, isinCode: isinCode };
          } else if (value && typeof value === 'object') {
            value.subscribe(val => (obj[col.name] = val));
          } else if (value) {
            obj[col.name] = col.options.value(d)
              ? col.options.value(d)
              : undefined;
          }
        });
        if (obj) return obj;
      }),
      this.simulationPackService.tableDefinitionColumn,
    );
    this.edited = true;
  }

  selectedPackChanged(pack: SimulationPack) {
    if (this.simulation) {
      this.simulationPackService.selectedPack = pack || { allocation: [] };
      this.simulationPackService.selectedPack.allocation.forEach(
        allocation =>
          (allocation.totalInvestedAmount =
            this.simulation.parameters.investedAmount),
      );
      this.initTable();
    }
  }

  triggerForm() {
    this.onEdit.emit();
    // Pour la SCPI : on ré-alimente l'éditeur « Modifier les SCPI » avec la liste distribuée
    // par le back (`completeParameters.scpiList`). C'est la seule source qui porte, par ligne,
    // les versements programmés + le réinvestissement répartis à partir des champs globaux
    // ET les flags d'éligibilité (`scpiPlanEpargneImmobilier` / `scpiReinvestissementDividendes`).
    // Sans ça, un pack nommé serait ré-amorcé depuis sa définition statique : colonnes vides
    // et désactivées (flags absents). Les autres produits conservent le comportement existant.
    const distributedScpiList =
      this.simulation?.type === 'SCPI' &&
      this.simulation?.completeParameters?.scpiList?.length
        ? this.simulation.completeParameters.scpiList
        : undefined;
    this.simulationPackService.startAllocationForm(
      this.simulation.parameters,
      distributedScpiList ??
        (this.simulationPackService.selectedPack.id
          ? this.simulationPackService.selectedPack.allocation
          : undefined),
    );
    if (this.simulationPackService.selectedPack.id)
      this.simulationPackService.selectPack(
        this.simulationPackService.getCustomPack(),
      );
  }

  ngOnDestroy(): void {
    this.alive = false;
  }
}
